module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }